import React from 'react';
import { Factory, AlertTriangle, TrendingUp } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 lg:py-32 bg-slate-950 relative border-t border-slate-900" data-id="element-212">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-214">
          {/* Content */}
          <div data-id="element-215">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-216">
              Waste and Energy Systems <br className="hidden md:block" data-id="element-217" />
              <span className="text-red-400" data-id="element-218">Are Broken</span>
            </h2>

            <div className="space-y-6 text-lg text-slate-300" data-id="element-219">
              <p data-id="element-220">
                Cities face rising waste management costs, increasing landfill
                overflow, and immense pressure to meet climate targets.
              </p>
              <p data-id="element-221">
                At the same time, energy production remains expensive and
                carbon-intensive. Methane emissions from waste are a major
                contributor to climate change — and largely untapped as a
                resource.
              </p>
            </div>

            <div className="mt-10 space-y-4" data-id="element-222">
              <div className="flex items-start gap-4 p-4 rounded-xl bg-slate-900/50 border border-slate-800" data-id="element-223">
                <div className="p-2 bg-red-500/10 rounded-lg shrink-0" data-id="element-224">
                  <AlertTriangle className="w-6 h-6 text-red-400" data-id="element-225" />
                </div>
                <div data-id="element-226">
                  <h4 className="text-white font-semibold mb-1" data-id="element-227">
                    Landfill Overflow
                  </h4>
                  <p className="text-slate-400 text-sm" data-id="element-228">
                    Municipalities are running out of space and paying premium
                    tipping fees.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 p-4 rounded-xl bg-slate-900/50 border border-slate-800" data-id="element-229">
                <div className="p-2 bg-orange-500/10 rounded-lg shrink-0" data-id="element-230">
                  <Factory className="w-6 h-6 text-orange-400" data-id="element-231" />
                </div>
                <div data-id="element-232">
                  <h4 className="text-white font-semibold mb-1" data-id="element-233">
                    Untapped Methane
                  </h4>
                  <p className="text-slate-400 text-sm" data-id="element-234">
                    Methane is 84x more potent than CO2 over 20 years, yet
                    mostly vents into the atmosphere.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Visual representation with image */}
          <div className="relative" data-id="element-235">
            <div className="absolute inset-0 bg-gradient-to-tr from-red-500/10 to-orange-500/10 rounded-3xl blur-2xl" data-id="element-236"></div>

            {/* Image overlay */}
            <div className="relative rounded-3xl overflow-hidden mb-6 border border-slate-800" data-id="element-237">
              <img src="https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?q=80&w=2070&auto=format&fit=crop" alt="Waste management challenges" className="w-full h-64 object-cover opacity-60" data-id="element-238" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent" data-id="element-239"></div>
            </div>

            <div className="relative bg-slate-900 border border-slate-800 rounded-3xl p-8 overflow-hidden" data-id="element-240">
              <div className="flex justify-between items-end mb-8 border-b border-slate-800 pb-8" data-id="element-241">
                <div data-id="element-242">
                  <div className="text-slate-400 text-sm font-medium mb-2" data-id="element-243">
                    Rising Waste Management Costs
                  </div>
                  <div className="text-4xl font-bold text-white" data-id="element-244">+34%</div>
                </div>
                <TrendingUp className="w-12 h-12 text-red-400 opacity-50" data-id="element-245" />
              </div>

              {/* Abstract Chart */}
              <div className="h-48 flex items-end gap-2" data-id="element-246">
                {[40, 45, 55, 60, 75, 85, 100].map((height, i) => <div key={i} className="flex-1 bg-gradient-to-t from-red-900/50 to-red-500/80 rounded-t-md transition-all duration-500 hover:opacity-80" style={{
                height: `${height}%`
              }} data-id="element-247"></div>)}
              </div>
              <div className="flex justify-between mt-4 text-xs text-slate-500 font-medium" data-id="element-248">
                <span data-id="element-249">2018</span>
                <span data-id="element-250">2021</span>
                <span data-id="element-251">2024</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}